// extracted by mini-css-extract-plugin
module.exports = {"main":"MonthSelectorStyles_main__2zef3","month":"MonthSelectorStyles_month__1INvR"};